export default "/images/vendor/flag-icon-css/flags/4x3/gf.svg?89cefa3814d2f748b377809d919e5e1c";